import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React, { useState } from "react";
import UploadCsvModal from "./upload-csv-modal";
import { useNavigate } from "react-router-dom";

export default function AddStockModal({ open, onClose }) {
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleAddStock = () => {
    handleModalClose();
    navigate("add");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "350px",
            gap: 4,
          }}
        >
          <Box
            sx={{
              border: "1px solid rgba(93, 106, 130, 1)",
              width: "40%",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "8px",
              p: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: "rgba(35, 42, 56, 1)", textAlign: "center" }}
            >
              Add Manually
            </Typography>
            <Typography
              sx={{ color: "rgba(93, 106, 130, 1)", textAlign: "center" }}
            >
              Enter all item information manually, one item at a time.
            </Typography>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderColor: "rgba(22, 63, 98, 1)",
                color: "rgba(22, 63, 98, 1)",
                width: "133px",
              }}
              onClick={handleAddStock}
            >
              Add Stock
            </Button>
          </Box>
          <Box
            sx={{
              border: "1px solid rgba(93, 106, 130, 1)",
              width: "40%",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "8px",
              p: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: "rgba(35, 42, 56, 1)", textAlign: "center" }}
            >
              Bulk Upload
            </Typography>
            <Typography
              sx={{ color: "rgba(93, 106, 130, 1)", textAlign: "center" }}
            >
              Upload all the item information directly through an Excel file.
            </Typography>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderColor: "rgba(22, 63, 98, 1)",
                color: "rgba(22, 63, 98, 1)",
                width: "133px",
              }}
              onClick={handleModalOpen}
            >
              Upload CSV
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <UploadCsvModal open={modalOpen} onClose={handleModalClose} />
    </Dialog>
  );
}
